/**
 * <ym-arrives data-min="5" data-max="9" data-closed="2026-11-26,2026-12-25">fallback</ym-arrives>
 * Replaces the fallback text with "Mon, Oct 19 – Fri, Oct 23": today plus min/max days, counting
 * weekends (workshops quote calendar days) and skipping the closed dates (same count as
 * snippets/ym-order-by.liquid).
 * With data-single only the last date shows; with data-short the dates go without weekdays and
 * share the month when they can ("Nov 3–7", "Oct 30 – Nov 4").
 *
 * <ym-order-by data-date="2026-10-16">…</ym-order-by>
 * Removes itself once that day has passed, for pages served from cache after the order-by date.
 */
(function () {
  /** @param {Date} date */
  function isoDate(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

  /**
   * @param {number} days
   * @param {string[]} closed
   */
  function addOpenDays(days, closed) {
    const date = new Date();
    let left = days;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      if (!closed.includes(isoDate(date))) left--;
    }
    return date;
  }

  /** @param {Date} date */
  function format(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /** @param {Date} from @param {Date} to */
  function formatShort(from, to) {
    const month = (/** @type {Date} */ d) => d.toLocaleDateString('en-US', { month: 'short' });
    if (from.getMonth() === to.getMonth()) return `${month(from)} ${from.getDate()}–${to.getDate()}`;
    return `${month(from)} ${from.getDate()} – ${month(to)} ${to.getDate()}`;
  }

  class YmArrives extends HTMLElement {
    connectedCallback() {
      const min = parseInt(this.dataset.min || '', 10);
      const max = parseInt(this.dataset.max || '', 10);
      if (!min || !max) return;
      const closed = (this.dataset.closed || '').split(',').filter(Boolean);
      const first = addOpenDays(min, closed);
      const last = addOpenDays(max, closed);
      if (this.hasAttribute('data-short')) {
        this.textContent = this.hasAttribute('data-single') || min === max ? format(last).replace(/^\w+, /, '') : formatShort(first, last);
      } else {
        this.textContent = this.hasAttribute('data-single') ? format(last) : `${format(first)} – ${format(last)}`;
      }
    }
  }

  class YmOrderBy extends HTMLElement {
    connectedCallback() {
      const date = this.dataset.date;
      if (date && isoDate(new Date()) > date) this.remove();
    }
  }

  if (!customElements.get('ym-arrives')) customElements.define('ym-arrives', YmArrives);
  if (!customElements.get('ym-order-by')) customElements.define('ym-order-by', YmOrderBy);
})();
